// extracted by mini-css-extract-plugin
export default {"container":"AcessoNegado_container__a7wcO","title":"AcessoNegado_title__9C5YQ","message":"AcessoNegado_message__j1u3G","button":"AcessoNegado_button__Fff-E"};